/** Self-funding sequence, step 2: what the coverage assessment will do (the shared introduction, unnumbered). */
import { AssessmentIntroduction } from '@/features/funding-sources';
import { FundingScreenFrame } from '../components/funding-screen-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import type { ConsumerStepProps } from './step-props';

export function AssessmentIntroStep({ clientId }: ConsumerStepProps) {
  const { goWithin } = useConsumerFlow(clientId);

  return (
    <AssessmentIntroduction
      onContinue={() => goWithin('assessment-accounts')}
      fullWidth
      onBack={() => goWithin('assets')}
      frame={parts => (
        <FundingScreenFrame
          step="assessment-intro"
          parts={{ ...parts, icon: undefined }}
        />
      )}
    />
  );
}
